import styled, { css } from "styled-components"
import { transparentize } from "polished"
import { P } from "../../../../typography"
import { TextField } from "../../../../forms"
import { Link } from "react-router-dom"
import breakpoint from "styled-components-breakpoint"
import Card from "../../../../card"

export const Container = styled.div`
  position: relative;
  color: ${({ theme }) => theme.colors.content.text};
`

export const StyledLink = styled(Link)`
  font-weight: 500;
  color: ${({ theme }) => theme.colors.body};
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const Title = styled(P)`
  font-size: 1.25rem;
  font-weight: 500;
`

export const Subtitle = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  ${({ showSeparator }) =>
    !!showSeparator &&
    css`
      &:before {
        content: "";
        border-left: 1px solid #dddddd;
        margin: 2px 0;
        align-self: stretch;
      }
    `}
`

export const StartDate = styled(P)`
  order: -1;

  @media only screen and (max-width: 764px) {
    font-size: 0.8rem;
  }
`

export const Interviews = styled(P)`
  margin: 0;
  color: #aaaaaa;

  @media only screen and (max-width: 764px) {
    font-size: 0.8rem;
  }

  ${({ positive }) =>
    !!positive &&
    css`
      color: #629f00;
    `}
`

export const Separator = styled.div`
  border-top: 1px solid #dddddd;
`

export const SearchBox = styled(TextField)`
  font-size: 0.75rem;
  padding: 0.5rem 1rem;
  background-color: #fff;
  border: 1px solid #d8d8d8;
  color: ${({ theme }) => theme.colors.secondaryAlternative || theme.colors.secondary};
  width: unset;
  font-weight: bold;

  &::placeholder {
    color: ${({ theme }) => transparentize(0.6, theme.colors.secondaryAlternative || theme.colors.secondary)};
  }

  ${breakpoint("tablet")`
    position: absolute;
    top: -2.5rem;
    right: 0;
  `}
`

export const RoleCard = styled(Card)`
  padding: 1.5rem;
  margin-top: 0.75rem;

  ${breakpoint("tablet")`
    padding: 2rem;
    margin-top: 0.5rem;
  `}
`
